import React, { Component } from 'react'

import NavItem from './NavItem/NavItem'
import { ReactComponent as AdjustersIcon } from '../../assets/images/icons/i-adjusters.svg'
import { ReactComponent as FiltersIcon } from '../../assets/images/icons/i-filters.svg'
import { ReactComponent as CropIcon } from '../../assets/images/icons/i-crop.svg'
import { ReactComponent as ResizeIcon } from '../../assets/images/icons/i-resize.svg'
import { ReactComponent as RotateIcon } from '../../assets/images/icons/i-rotate.svg'
import { ReactComponent as CensorIcon } from '../../assets/images/icons/i-censor.svg'
import { ReactComponent as OverlayIcon } from '../../assets/images/icons/i-overlay.svg'
import { ReactComponent as SmileIcon } from '../../assets/images/icons/i-smile.svg'
import { ReactComponent as StampIcon } from '../../assets/images/icons/i-stamp.svg'
import { ReactComponent as TitlesIcon } from '../../assets/images/icons/i-titles.svg'
import DesktopModal from '../Common/DesktopModal/DesktopModal'

class Nav extends Component {
  state = {
    isModalOpen: false
  }

  openModal = () => {
    this.setState({
      isModalOpen: true
    })
  }

  onModalClose = () => {
    this.setState({
      isModalOpen: false
    })
  }

  render() {
    const { isModalOpen } = this.state

    return (
      <>
        <nav className="nav">
          <NavItem
            to="/"
            translationKeyTooltip='titles.adjust'
          >
            <AdjustersIcon />
          </NavItem>
          <NavItem
            to="/crop"
            translationKeyTooltip='titles.crop'
          >
            <CropIcon />
          </NavItem>
          <NavItem
            to="/rotate"
            translationKeyTooltip='titles.rotate'
          >
            <RotateIcon />
          </NavItem>
          <NavItem
            to="/resize"
            translationKeyTooltip='titles.resize'
          >
            <ResizeIcon />
          </NavItem>
          <NavItem
            to="/filters"
            translationKeyTooltip='titles.effects'
          >
            <FiltersIcon />
          </NavItem>
          <NavItem
            id="gtm-peo-ANB-1559-click-icon-smart-eraser"
            onClick={this.openModal}
            translationKeyTooltip='titles.stamp'
          >
            <StampIcon />
          </NavItem>
          <NavItem
            id="gtm-peo-ANB-1559-click-icon-insert-image"
            onClick={this.openModal}
            translationKeyTooltip='titles.overlay'
          >
            <OverlayIcon />
          </NavItem>
          <NavItem
            id="gtm-peo-ANB-1559-click-icon-change-background"
            onClick={this.openModal}
            translationKeyTooltip='titles.censor'
          >
            <CensorIcon />
          </NavItem>
          <NavItem
            id="gtm-peo-ANB-1559-click-icon-retouching"
            onClick={this.openModal}
            translationKeyTooltip='titles.smile'
          >
            <SmileIcon />
          </NavItem>
          <NavItem
            id="gtm-peo-ANB-1559-click-icon-text"
            onClick={this.openModal}
            translationKeyTooltip='titles.titles'
          >
            <TitlesIcon />
          </NavItem>
        </nav>
        <DesktopModal isOpen={isModalOpen} onCLose={this.onModalClose} />
      </>
    )
  }
}

export default Nav
